import {
  AnalyticsEvent,
  EventParameters,
} from "@adsk/acc-issues-core/utils/analytics/analyticsTypes";

export class IssueEditBulkDeleteClickEvent implements AnalyticsEvent {
  name = "issue.edit.bulk.delete.click";
  parameters: EventParameters;

  constructor(params: { numberOfIssues: number }) {
    this.parameters = {
      ...params,
    };
  }
}
